export enum VideoEventCode {
    Unknown = -1,
    Button = 0,
    Speed = 1,
    Acceleration = 2,
    LowShock = 3,
    MediumShock = 4,
    HighShock = 5,
    Braking = 6,
    Turning = 7,
    UserRequested = 8,
    Sensor = 9,
    Exception = 10,
    Motion = 11,
    PowerOff = 12,
    DriverFatigue = 13,
    DriverOnPhone = 14,
    DriverSmoking = 15,
    DriverDistraction = 16,
    DriverAbsent = 17,
    Pedestrian = 18,
    Collision = 19,
    LaneDeparture = 20,
    VehicleTooClose = 21,
    DriverLogin = 22,
    BlindSpot = 23,
    NoSeatBelt = 24,
    DriverYawn = 25,
    CameraCovered = 26,
    SpeedLimitSign = 27,
    SpeedWarning = 28,
    StopSignAlarm = 29
}
